import React, { useContext } from "react";

import ContractTab from "./ContractItem";
import ContractReceiptsTab from "./ContractReceipts";
import ContractWithdrawsTab from "./ContractWithdraws";

import { StoreContext } from "shared/context/store-context";
import Tabs from "components/ui/tabs/Tabs";

const ContractAnalyzer = ({ isNewItem, contract, onClose }) => {
  const {
    UpdateContract,
    InsertContract,
    DeleteContract,
    InsertReceipt,
    UpdateReceipt,
    DeleteReceipt,
    InsertWithdraw,
    UpdateWithdraw,
    DeleteWithdraw,
  } = useContext(StoreContext);

  const contractAnalyzerTabs = React.useMemo(() => {
    const contractItemTab = (
      <ContractTab
        contract={contract}
        isNewItem={isNewItem}
        InsertItem={InsertContract}
        UpdateItem={UpdateContract}
        DeleteItem={DeleteContract}
        onClose={onClose}
      ></ContractTab>
    );

    const contractReceiptsTab = (
      <ContractReceiptsTab
        contract={contract}
        InsertItem={InsertReceipt}
        UpdateItem={UpdateReceipt}
        DeleteItem={DeleteReceipt}
      ></ContractReceiptsTab>
    );

    const contractWithdrawsTab = (
      <ContractWithdrawsTab
        contract={contract}
        InsertItem={InsertWithdraw}
        UpdateItem={UpdateWithdraw}
        DeleteItem={DeleteWithdraw}
      ></ContractWithdrawsTab>
    );

    return [
      {
        label: "Sözleşme Bilgileri",
        content: contractItemTab,
      },
      {
        label: "Sözleşme Tahsilatları",
        content: contractReceiptsTab,
      },
      {
        label: "Sözleşme İadeleri",
        content: contractWithdrawsTab,
      },
    ];
  }, [
    DeleteContract,
    DeleteReceipt,
    InsertContract,
    InsertReceipt,
    UpdateContract,
    UpdateReceipt,
    contract,
    isNewItem,
    onClose,
  ]);

  return (
    <React.Fragment>
      <Tabs tabs={contractAnalyzerTabs} isVertical={false} />
    </React.Fragment>
  );
};

export default ContractAnalyzer;
